import { getParkingType } from 'store/selectors/selectors';
import { useSelector } from 'react-redux';
import { useCurrentPathname } from 'hooks/use-current-pathname';
function isParkingTypeIncludedInRevamp(parkingType) {
    const isMatchingParkingType = parkingType === 'transient' ||
        parkingType === 'monthly' ||
        parkingType === 'event' ||
        parkingType === 'power_booking' ||
        parkingType === 'airport';
    return isMatchingParkingType;
}
export const useShowNewSearchHeader = () => {
    const pathname = useCurrentPathname();
    const parkingType = useSelector(getParkingType);
    const isMatchingParkingType = isParkingTypeIncludedInRevamp(parkingType);
    return isMatchingParkingType && pathname === '/search';
};
